<div class="timekeeping-toolbar layout-row layout-align-start-center">

  <bz-search-input class="timekeeping-search-input margin-right-20"
                   appBringozIdGenerator="timekeeping-search-input"
                   [debounceMs]="searchDebounceMs"
                   [placeholder]="'Search' | translate"
                   [ariaLabel]="'Search' | translate"
                   [value]="searchQuery()"
                   (valueChange)="searchChange.emit($event)">
  </bz-search-input>

  <!--Date Filter-->
  <div class="layout-row layout-align-start-center">
    <bz-button variant="tertiary"
               tone="primary"
               size="fit"
               appBringozIdGenerator="decreaseDaysBtn"
               [ariaLabel]="'Previous Week' | translate"
               (clicked)="browseWeek.emit(false)">
      <bz-icon [icon]="chevronLeftIcon"></bz-icon>
    </bz-button>

    <app-bringoz-date-range-picker [customTemplates]="customTemplates"
                                   [selectedRange]="range()"
                                   (onChange)="onRangeSelect($event)">
    </app-bringoz-date-range-picker>

    <bz-button variant="tertiary"
               tone="primary"
               size="fit"
               appBringozIdGenerator="increaseDaysBtn"
               [ariaLabel]="'Next Week' | translate"
               (clicked)="browseWeek.emit(true)">
      <bz-icon [icon]="chevronRightIcon"></bz-icon>
    </bz-button>
  </div>

  <div class="timekeeping-toolbar-filters layout-row layout-align-start-center">

    <!--Employee Role-->
    <app-custom-select-filter appBringozIdGenerator="timekeeping-agent-tags-filter"
                              placeholder="Employee Role"
                              countLabelKey="X_EMPLOYEE_ROLES"
                              [icon]="agentTagsIcon"
                              [options]="agentTagOptions()"
                              [selectedIds]="filters()?.tags"
                              (selectionChange)="agentTagsChange.emit($event)">
    </app-custom-select-filter>

    <!--Region / Market-->
    <app-custom-select-filter appBringozIdGenerator="timekeeping-group-tags-filter"
                              placeholder="Region / Market"
                              countLabelKey="X_REGIONS_MARKETS"
                              [icon]="groupTagsIcon"
                              [options]="groupTagOptions()"
                              [selectedIds]="filters()?.groupTags"
                              (selectionChange)="groupTagsChange.emit($event)">
    </app-custom-select-filter>

    <!--Teams-->
    <app-custom-select-filter appBringozIdGenerator="timekeeping-groups-filter"
                              placeholder="Teams"
                              countLabelKey="X_TEAMS"
                              [icon]="groupsIcon"
                              [options]="groupOptions()"
                              [selectedIds]="filters()?.groupIds"
                              (selectionChange)="groupIdsChange.emit($event)">
    </app-custom-select-filter>

    <!--Territories-->
    <app-custom-select-filter appBringozIdGenerator="timekeeping-branches-filter"
                              placeholder="Territories"
                              countLabelKey="X_TERRITORIES"
                              [icon]="branchesIcon"
                              [options]="branchOptions()"
                              [selectedIds]="filters()?.branchIds"
                              (selectionChange)="branchIdsChange.emit($event)">
    </app-custom-select-filter>

    <!--Timecard Status Filter-->
    <bz-select class="timekeeping-status-select"
               appBringozIdGenerator="timekeeping-status-select"
               size="sm"
               [multiple]="true"
               [options]="statusOptions()"
               [placeholder]="'All Statuses' | translate"
               [ariaLabel]="'Status' | translate"
               [value]="selectedStatuses()"
               (valueChange)="onStatusesSelect($event)">
    </bz-select>

  </div>

  <span class="flex"></span>

  <!--Export-->
  <div *ngxPermissionsOnly="'timekeeping.timeCard.export'">
    @if (exporting()) {
      <bz-icon class="timekeeping-export-icon-disabled" [icon]="exportXslIcon" [label]="'Export' | translate"></bz-icon>
    } @else {
      <bz-menu appBringozIdGenerator="timekeeping-export-button"
               [items]="exportMenuItems()"
               [ariaLabel]="'Export' | translate"
               (selected)="onExportSelected($event)">
        <bz-icon [icon]="exportXslIcon"></bz-icon>
      </bz-menu>
    }
  </div>

  <!--Table Settings-->
  <bz-tooltip placement="bottom" [content]="'Settings' | translate">
    <bz-button variant="tertiary"
               tone="primary"
               size="fit"
               appBringozIdGenerator="timekeeping-settings-button"
               [ariaLabel]="'Settings' | translate"
               (clicked)="openSettings.emit($event)">
      <bz-icon [icon]="settingsIcon"></bz-icon>
    </bz-button>
  </bz-tooltip>

  <!--Complete-->
  <bz-button variant="outline"
             tone="secondary"
             class="margin-left-10"
             appBringozIdGenerator="timekeeping-complete-button"
             [disabled]="completeDisabled()"
             (clicked)="completeTimecards.emit()">
    <span>{{ 'Complete' | translate }}</span>
  </bz-button>

</div>
